import * as React from 'react';
import TextareaAutosize from 'react-autosize-textarea';
import { Label } from '@fluentui/react/lib/Label';
import { SavingState } from '../api/savingState';

export interface FormTextareaOptions {
    disabled?: boolean;
}

interface FormTextareaProps {
    label: string;
    value: string;
    onChange: (newValue: string | number) => void;
    savingState: SavingState;
    options: FormTextareaOptions;
}

export const FormTextarea: React.FC<FormTextareaProps> = ({ label, value, savingState, options, onChange }) => {
    return (
        <>
            <Label>{label}</Label>
            <TextareaAutosize
                style={{ width: 'calc(100% - 18px)', padding: '4px 8px', minHeight: 80, resize: 'vertical' }}
                disabled={savingState === SavingState.saving || options.disabled}
                value={value}
                onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) => onChange(event.target.value)}
            />
        </>
    );
};
